"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignModal = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const Page = (0, app_1.styled)(ui_1.FormPage) `
  text-align: center;
`;
const StyledModal = (0, app_1.styled)(ui_1.Modal) `
  section {
    border-top: none !important;
  }
  h2 {
    font-size: 1.625rem;
  }
  p {
    color: ${(theme) => theme.colors.gray.semidark};
  }
  span {
    text-align: left;
  }
`;
const FormStack = (0, app_1.styled)(ui_1.Stack) `
  margin: 3rem 0;
`;
function SignModal() {
    const { t } = (0, app_1.useTranslation)();
    const { open, hide } = (0, app_1.useParamModal)(SignModal.PARAM);
    const [submitEntry] = (0, app_1.useMutation)('signToMailingList');
    const handleSubmit = ({ email, phone, }) => {
        void submitEntry({
            email,
            phone,
            mailingList: 'opening',
        });
        return ui_1.SubmitState.OK;
    };
    return ((0, jsx_runtime_1.jsxs)(StyledModal, Object.assign({ open: open, onSubmit: handleSubmit, onClose: hide }, { children: [(0, jsx_runtime_1.jsxs)(Page, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h2" }, { children: t('template.underConstruction.modal.title') })), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ as: "caption-1" }, { children: t('template.underConstruction.modal.description') })), (0, jsx_runtime_1.jsxs)(FormStack, Object.assign({ kind: "vertical", spacing: "1.125rem" }, { children: [(0, jsx_runtime_1.jsx)(ui_1.TextInput, { name: "email", label: "E-mail", type: "email" }), (0, jsx_runtime_1.jsx)(ui_1.TextInput, { name: "phone", label: "Phone" }), (0, jsx_runtime_1.jsx)(ui_1.CheckboxInput, { required: true, name: "rodo", label: t('label.rodo') })] })), (0, jsx_runtime_1.jsx)(ui_1.Submit, { children: t('template.underConstruction.modal.alert') })] }), (0, jsx_runtime_1.jsx)(ui_1.FormPage, Object.assign({ successPage: true }, { children: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h2" }, { children: t('text.thankYou') })) }))] })));
}
exports.SignModal = SignModal;
SignModal.PARAM = 'sign';
